import { Input } from 'antd';
import React from 'react';
import SgiCtlComponent from './sgiBaseComp/SgiCtlComponent';

export default class SgiPassword extends SgiCtlComponent {

	constructor(props) {
		super(props);
		this.state = {
		};
		this.data = {
			...this.data,
			maskChar: this.props.maskChar || "●",
			selectionStart: 0,
			selectionEnd: 0,
			realVal: "",
		};
	}

	_onInput = (e) => {
		var showVals = e.target.value.split("");
		var hideVals = this.data.realVal.split("");
		var start = e.target.selectionStart;
		var length = Math.abs(this.data.selectionEnd - this.data.selectionStart);
		if (length == 0) {
			if (showVals.length < hideVals.length) {
				hideVals.splice(start, 1);
			} else {
				hideVals.splice(start - 1, 0, showVals[start - 1]);
			}
		} else {
			if (showVals.length < hideVals.length) {
				hideVals.splice(start, length);
			} else {
				hideVals.splice(start - 1, length, showVals[start - 1]);
			}
		}
		var showVal = "";
		let maskChar = this.data.maskChar;
		for (var i = 0; i < showVals.length; i++) {
			showVal += maskChar;
		}
		e.target.value = showVal;
		this.data.realVal = hideVals.join("");

		e.target.selectionEnd = start;

		// 真值回调
		if (this.props.realVal && typeof this.props.realVal === "function") {
			this.props.realVal(this.data.realVal);
		}
	}

	_onKeydown = (e) => {
		this.data.selectionStart = e.target.selectionStart;
		this.data.selectionEnd = e.target.selectionEnd;
	}

	render = () => <Input {...this.props} onKeyDown={this._onKeydown} onInput={this._onInput} />
}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiPassword.js